/**
 * "Saved 3s ago" / "Saved at 2:14 PM" formatter for the autosave pill.
 * Honest about precision: <60s uses seconds, <1h minutes, otherwise the
 * clock time.
 */
export function formatRelative(timestamp, now = Date.now()) {
    if (!timestamp) return '';
    const diff = Math.max(0, now - timestamp);
    if (diff < 5_000) return 'just now';
    if (diff < 60_000) return `${Math.round(diff / 1000)}s ago`;
    if (diff < 60 * 60_000) return `${Math.round(diff / 60_000)}m ago`;
    const d = new Date(timestamp);
    return `at ${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`;
}
